export interface DatosGenerales{
    iddecinvproyectodatosgenerales :number            
    iddecinvproyecto               :number,     
    titulo                         :string,  
    tipoproyecto                   :number ,    
    tipoinvestigacion              :number,    
    objetivogeneral                :string,
    meses                          :number,   
    fechainicio                    :string,
    fechafin                       :string,
    ultimoCambio                   :string,
    idobjetivoecfrascati           :number,     
    eseditable                     :number,     
    iddecinvprograma               :number,     
    idunidad                       :number,     
    fechafinoriginal               :string
}

export function getVoidDatosGenerales(){
    return{
        iddecinvproyectodatosgenerales :0,            
        iddecinvproyecto               :0,     
        titulo                         :'',  
        tipoproyecto                   :0,    
        tipoinvestigacion              :0,    
        objetivogeneral                :'',
        meses                          :0,   
        fechainicio                    :'',
        fechafin                       :'',
        ultimoCambio                   :'',
        idobjetivoecfrascati           :0,     
        eseditable                     :0,     
        iddecinvprograma               :0,     
        idunidad                       :0,     
        fechafinoriginal               :''
    }
}

export function setDatosGenerales(data: any){
    let datos = getVoidDatosGenerales();
    datos.iddecinvproyectodatosgenerales=data.iddecinvproyectodatosgenerales??0;            
    datos.iddecinvproyecto= data.iddecinvproyecto??0;     
    datos.titulo= data.titulo??'';  
    datos.tipoproyecto= data.tipoproyecto??0;    
    datos.tipoinvestigacion= data.tipoinvestigacion??0;    
    datos.objetivogeneral= data.objetivogeneral??'';
    datos.meses= data.meses??0;   
    datos.fechainicio= data.fechainicio??'';
    datos.fechafin= data.fechafin??'';
    datos.ultimoCambio= data.ultimoCambio??'';
    datos.idobjetivoecfrascati= data.idobjetivoecfrascati??0;     
    datos.eseditable= data.eseditable??0;
    datos.iddecinvprograma= data.iddecinvprograma??0;     
    datos.idunidad= data.idunidad??0;
    datos.fechafinoriginal= data.fechafinoriginal??'';
    return datos;
}